
import { Status, ajax, cleanObject, evalJson, isEmpty, toQueryString, } from '../twd/twd'
import { MODES } from './use-order-ticket'

let lastAbortAjax = null

export const reset = async ({
    action, acctNo, cusip, qty, priceOrYield, price, yld, mode,
    sourceAction_, sourceOrderNo_,
    setPrice, setYld,
    setBestPrice, setBestYield,
    setOrderInfoStatus, setOrderInfo, setHiddenState, setErrors,
    callback,
    isPreview,
    isTreasuryAuction,
}) => {

    if (!cusip || !action || !acctNo) {
        setOrderInfo({})
        setHiddenState({})
        setOrderInfoStatus(Status.LOADED)
        setErrors({})
        if (callback) { callback({}) }
        return
    }

    try {
        if (lastAbortAjax) { lastAbortAjax() }

        setErrors({})
        setOrderInfoStatus(Status.LOADING)

        const params = cleanObject({
            p_acct_no: acctNo,
            p_action: action,
            p_cusip: cusip,
            p_qty_bond: qty,
            p_output_format: 'JSON',
            p_source_action: isTreasuryAuction ? 'A' : sourceAction_,
            p_source_order_no: sourceOrderNo_,
        })

        const { data:order_, abort:abort_ } = await ajax({
            url: '/esb/portfolio/trades/orderOutput',
            method: 'POST',
            headers_: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: toQueryString(params),
            type: 'text',
        })

        lastAbortAjax = abort_

        const info = evalJson(await order_, {})
        if (isPreview) {
            setOrderInfoStatus(Status.LOADED)
            return info
        }

        const isLift = mode===MODES.ORDER_Z
        info.netMoney = null
        info.sugg_comm_in_dlrs_per_tckt = null

        setOrderInfo(info)
        setHiddenState({...(info.hiddenState)})

        if (isTreasuryAuction) {
            info.qty_max = 10000
        }
        if (isEmpty(price) && !isEmpty(info.price) && priceOrYield===1) {
            setPrice(info.price)
        }
        if (isEmpty(yld) && !isEmpty(info.yield) && (priceOrYield===0 ||  isLift)) {
            setYld(info.yield)
        }
        if (!isEmpty(info.price)) { setBestPrice(info.price) }
        if (!isEmpty(info.yield)) { setBestYield(info.yield) }


        setOrderInfoStatus(Status.LOADED)

        if (callback) { callback(info) }

    } catch (e) {
        const isAbort = e.toString().indexOf('AbortError')>=0
        if (!isAbort) {
            console.error('use-order-ticket-reset', e)
            setOrderInfoStatus(Status.FAILED_TO_LOAD)
        }
        setOrderInfo({})

        if (callback) { callback({}) }
    }
}


// WEBPACK FOOTER //
// ./src/order-ticket/use-order-ticket-reset.js